// Debugging confirmation
console.log('✅ Blank Master Page Builder loaded successfully!');

import { getMasterLayoutContentByFolderPath } from '../js/build-manager-utils.js';

// Blank Master Page Builder
export async function buildMasterLayoutBlank() {
  console.log(`🔄 Blank Master Page Builder - Starting to build master page`);

  try {
    // Get the master layout content
    let masterPageLayoutContent = await getMasterLayoutContentByFolderPath(
      'layouts/master-layout-blank'
    );

    console.log(`🔄 Blank Master Page Builder - Master page content loaded successfully`);

    // Return the master page content as the result
    let result = masterPageLayoutContent;

    return result;
  } catch (error) {
    console.error('❌ Error building blank master page content:', error);
    return 'Error loading blank master page content.';
  }
}
